import { system } from "portalframework";
import * as ko from "knockout";
import { new_user } from "organized";
import { portalHttpService } from "../_common/httpService";
import { USER_LANGUAGE_KEY } from "app/app-constants";

class RegisterService {
  getUserPlaceIds = async () => {
    return await portalHttpService.get<any>(system.apiURL() + "api/Account/GetPlaceIds");
  };

  verifyEmailAndPlace = async (user: new_user): Promise<any> => {
    return await portalHttpService.post<any>(system.apiURL() + "api/Account/SelfRegisterVerifyEmail", ko.toJSON(user));
  };
  register_user = async (user: new_user): Promise<any> => {
    return await portalHttpService.post<any>(system.apiURL() + "api/Account/Register", ko.toJSON(user));
  };

  confirm_user = async (key: string) => {
    const locale = localStorage.getItem(USER_LANGUAGE_KEY);
    return await portalHttpService.post<any>(
      system.apiURL() + "api/Account/confirm",
      ko.toJSON({ key: key, locale: locale }),
    );
  };

  verify_user = async (key: string, code: string) => {
    const locale = localStorage.getItem(USER_LANGUAGE_KEY);
    return await portalHttpService.post<any>(
      system.apiURL() + "api/Account/verify",
      ko.toJSON({ key: key, code: code, locale: locale }),
    );
  };

  selfRegisterOpenTicket = async (user: new_user): Promise<any> => {
    const locale = localStorage.getItem(USER_LANGUAGE_KEY);
    user.language(locale);
    return await portalHttpService.post<any>(system.apiURL() + "api/Account/SelfRegisterOpenTicket", ko.toJSON(user));
  };
  openTicketNoAccessRights = async (): Promise<any> => {
    const locale = localStorage.getItem(USER_LANGUAGE_KEY);
    const result = await portalHttpService.post<any>(
      system.apiURL() + "api/Account/OpenTicketNoAccessRights",
      ko.toJSON({ locale: locale }),
    );
    return result?.message;
  };
}
export const registerService = new RegisterService();
